var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"me-tabs"},[_c('div',{staticClass:"me-tabs__wrapper"},[_vm._l((_vm.chapters),function(chapter,idx){return [_c('me-tab',{key:idx,class:[
          _vm.selected === idx || chapter.active && _vm.allPossibles ? 'current'
          : chapter.active ? 'possible'
          : 'disabled'
        ],attrs:{"chapter":chapter,"id":idx},on:{"current":_vm.checkCurrentTab}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }